import { Connection } from '@solana/web3.js'
import * as anchor from "@project-serum/anchor";
import axios from 'axios';
import { Soldegen } from "../idl/soldegen/soldegen";
import idl from "../idl/soldegen/soldegen.json"
import { SOLDEGEN_ERRORS, SOL } from "../constants/constants";

const multiplierArr = SOL

const sleep = (ms) => {
  return new Promise(
    resolve => setTimeout(resolve, ms)
  );
}    
export const getBets = async (multiplier, token) => {
    // console.log("TOKEN IS", token)
    let search = {token: "SOL"}
    if (multiplier) search["multiplier"] = multiplier
    if (token) search["token"] = token
    const serverUrl = process.env.REACT_APP_DATA_SERVER + "/recentBets"
    const { data } = await axios.post(
        serverUrl,
        search,
        {}
    );  
    // console.log(data)
    return data        
}

export const getBetsByUser = async (wallet, multiplier, amount, token, period) => {
    let search = {token: "SOL"}
    // console.log("TOKEN IS", token)
    if (wallet) search["wallet"] = wallet;
    if (multiplier) search["multiplier"] = multiplier
    if (token) search["token"] = token
    if (amount) search["amount"] = amount
    if (period) search["period"] = period
    const serverUrl = process.env.REACT_APP_DATA_SERVER + "/getBetsByUser"
    const { data } = await axios.post(
        serverUrl,
        search,
        {}
    );  
    // console.log(data)
    return data        
}


export const playBet = async (amount, multiplier, wallet, dispatch, setBetAmount, setBetMultiplier, setLoaderMsg, setGameState, setLoaderImage) => {
  try {   
      // console.log("PLAYING", amount, multiplier, wallet)
      const connection = new Connection(process.env.REACT_APP_RPC_URL, {commitment: "confirmed",confirmTransactionInitialTimeout:120000});
      const program_id = process.env.REACT_APP_SOLDEGEN_PROGRAM_ID
      const programId = new anchor.web3.PublicKey(program_id);
      const provider = new anchor.AnchorProvider(connection, wallet, anchor.AnchorProvider.defaultOptions())  
      let player = provider.wallet.publicKey
      anchor.setProvider(provider);
      const program = new anchor.Program(
          idl,
          programId,
          provider,
          new anchor.BorshCoder(idl)
      ) as anchor.Program<Soldegen>;
      let pubkeyGlobal = new anchor.web3.PublicKey("B8yRXKYau5bJkneLwUfduzyvmz11GspXDK1bn19Vfiww")
      let feeaccount = new anchor.web3.PublicKey("3z9qkHLuLJGd32LCPGNAXJAVNoAPgpTLdcHNhWQmH3B3")
      let [globalAccount] = await anchor.web3.PublicKey.findProgramAddressSync(
          [Buffer.from("GLOBAL_VAULT"), pubkeyGlobal.toBuffer()],
          program.programId
      );
      let [palyerAccount] = await anchor.web3.PublicKey.findProgramAddressSync(
          [Buffer.from("PLAYER_ACCOUNT"), wallet.publicKey.toBuffer()],
          program.programId
      );        

      let sol_to_lamport = Math.floor(amount * 1000000000); // users want to bet 3.3 SOL

      let isUserAccountExist = null
      let playerAccountData = null
      try {
          isUserAccountExist = await program.account.playerState.getAccountInfo(
            palyerAccount
          );
      } catch (err1) {
          // console.log(err1)
      }

      const multiplierVal = multiplierArr.find(el => el.value == multiplier); // user want to chose first multipler hence 0
      // console.log(multiplierArr)
      let multiplierIndex = multiplierVal["index"]
      // console.log(multiplierIndex)
      let userTx;
      let msg = multiplier + "x bet with " + amount + " SOL"
      setLoaderMsg(<div>Confirming Deposit<br/>{msg}</div>)
      if (isUserAccountExist == null) {

        userTx = await program.methods
          .initPlay(multiplierIndex, new anchor.BN(sol_to_lamport))
          .accounts({
            globalAccount: globalAccount,
            playerAccount: palyerAccount,
            admin: pubkeyGlobal,
            feeAccount: feeaccount,
            payer: player, // basically the one who signs the tx is player
            systemProgram: anchor.web3.SystemProgram.programId,
          })
          .rpc();

      } else {
        playerAccountData = await program.account.playerState.fetch(palyerAccount);

        userTx = await program.methods
          .play(multiplierIndex, new anchor.BN(sol_to_lamport))
          .accounts({
            globalAccount: globalAccount,
            playerAccount: palyerAccount,
            admin: pubkeyGlobal,
            feeAccount: feeaccount,
            payer: player, // basically the one who signs the tx is player
            systemProgram: anchor.web3.SystemProgram.programId,
          })
          .rpc();
      }
      setLoaderImage("images/trident2.gif")
      setLoaderMsg(<div>Deposit Confirmed<br/>{msg}</div>)
      // const playerTx = await connection.confirmTransaction(userTx);
      // await sleep(3000)
      const serverUrl = process.env.REACT_APP_BET_SERVER + "/placeBet"
      const { data } = await axios.post(
        serverUrl,
        { player: wallet.publicKey.toBase58(), multiplier: multiplier, amount: amount },
        { }
      );
      data["status"] = "success"
      return data
  } catch (err) {
    console.log(err)
      if (err["error"]["errorCode"]["number"] == 6003){
          let oldBetAmount = err["logs"][2].split("Bet Amount: ").pop()
          oldBetAmount = oldBetAmount/1000000000
          let oldMultiplierAmount = err["logs"][3].split("Multiplier: ").pop()
          dispatch(setBetAmount(oldBetAmount))
          dispatch(setBetMultiplier(oldMultiplierAmount))
          let msg = "COMPLETING A PREVIOUSLY UNFINISHED " + oldMultiplierAmount + "X BET WITH "+ oldBetAmount +" SOL"
          setLoaderMsg(msg)
          const serverUrl = process.env.REACT_APP_BET_SERVER + "/placeBet"
          try {
            const { data } = await axios.post(
              serverUrl,
              { player: wallet.publicKey.toBase58(), multiplier: oldMultiplierAmount, amount: oldBetAmount },
              { }
            );
            data["status"] = "success"
            return data          
          } catch (error) {
            // console.log(error)
            return handleError(error)  
          }
      } else {
          return handleError(err)
      }
      
  }
}


const handleError = (error) => {
  let data = {status: "error encountered"}
  // console.log("handling erro")
    // console.log(error)
  if ( (error.code == "ERR_BAD_RESPONSE") && (error.hasOwnProperty('response')) && (error["response"].hasOwnProperty('data')) && (error["response"]["data"].hasOwnProperty('code')) ) {
    let errorCode = error['response']['data']['code'];
    // console.log(SOLDEGEN_ERRORS[errorCode]["msg"])
    data["loaderImg"] = SOLDEGEN_ERRORS[errorCode]["loaderImg"]
    data["msg"] = SOLDEGEN_ERRORS[errorCode]["errorMsg"]
    if (errorCode == "6007"){
      data["status"] = "paused game"
      data["subMsgs"] =[ SOLDEGEN_ERRORS[errorCode]["subMsg1"], SOLDEGEN_ERRORS[errorCode]["subMsg2"]] 
    }
    return data;
  }
}